// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ho-6";
export var emphasizeQuantity = "_ho-3";
export var flatBottomCorners = "_ho-5";
export var productImage = "_ho-0";
export var quantityContainer = "_ho-2";
export var tooltip = "_ho-1";
export var wrapAndEllipsesOverflow = "_ho-4";